import { useContext } from "react";
import { Helmet } from "react-helmet";
import STUtils from "../../assets/styles/utility.module.scss";
import Footer from "../organisms/Footer";
import Header from "../organisms/Header";

import PAGE_CONFIG from "../../config/page";
import { SiteContext } from "../../providers/SiteProvider";
import MypageBackground from "../organisms/MypageBackground";

type Props = {
  title: string;
  login: boolean;
  hasBackground?: boolean;
  subdomain: string;
  showFooter?: boolean;
  customMainStyle?: React.CSSProperties;
  hasNavigationBar?: boolean;
  hasBackButton?: boolean;
};

const BaseHead: React.FC<Props> = ({
  title,
  login,
  children,
  hasBackground = false,
  subdomain,
  showFooter = true,
  customMainStyle,
  hasNavigationBar,
  hasBackButton
}) => {
  const styleUrl = `${PAGE_CONFIG.CDN_ENDPOINT}/${subdomain}/${PAGE_CONFIG.STATIC_STYLE_FILE_PATH}`;
  const site = useContext(SiteContext);
  return (
    <>
      <Helmet>
        <title>{`${title} | ${site.name}`}</title>
        <link rel="stylesheet" href={styleUrl}></link>
        <meta property="og:site_name" content={site.name} />
        <meta property="og:title" content={`${title} | ${site.name}`} />
      </Helmet>

      <MypageBackground hasBackground={hasBackground}>
        <Header hasBackButton={hasBackButton} login={login} subdomain={subdomain} />
        <main>
          <div role="main" className={STUtils.main_new} style={customMainStyle}>
            {children}
          </div>
        </main>
        {showFooter ? 
            <Footer hasNavigation={hasNavigationBar} hasBackground={hasBackground} /> 
          : 
          <></>}
      </MypageBackground>
    </>
  );
};

export default BaseHead;
